import { api } from "@/lib/axios";
import { User } from "@/types/user";

type UpdateData = {
  name?: string;
  lastName?: string;
  username: string;
  password?: string;
  role: { _id: string; name: string };
  email: string;
  phone?: string;
  campaign?: string;
};

const update = (id: string, user: UpdateData): Promise<User> =>
  api.put(`/users/${id}`, user).catch(() => null) as unknown as Promise<User>;

export default update;
